import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ProjectService } from 'src/app/projects/project.service';

@Component({
  selector: 'app-modal-markers-photo',
  templateUrl: './modal-markers-photo.component.html',
  styleUrls: ['./modal-markers-photo.component.scss'],
})
export class ModalMarkersPhotoComponent implements OnInit {
  @Input() heading: string = '';
  @Input() show: boolean = false;
  @Input() content: string = '';
  @Input() url: string = '';
  @Output() showChange: EventEmitter<boolean> = new EventEmitter();
  dataUrl = '';

  constructor(private _project: ProjectService) {}

  async ngOnInit(): Promise<void> {
    if (this._project.currentProject) {
      this.dataUrl = await this._project.getMediaUrl(
        this._project.currentProject,
        this.url
      );
    }
  }

  closeModal() {
    this.showChange.emit(false);
  }
}
